import type { OptionsDocument } from 'paintscout'
import type { FeatureProduct } from '../../options'

export const getFeatureProducts = ({ options }: { options: OptionsDocument }): { [key: string]: FeatureProduct } => {
  const featureProducts: { [key: string]: FeatureProduct } = {}
  Object.keys(options.options?.products?.values).forEach((key) => {
    const product = options.options.products.values[key]
    if (product.featureProduct) {
      featureProducts[key] = {
        key,
        label: product.label,
        description: product.description,
        featureImage: product.featureImage,
        featureProduct: true
      }
    }
  })

  return featureProducts
}
